import React from "react"
import closeIcon from '../../../../assests/header/close.png'
import { onKeyDown } from "../../../../service"
import classes from './IconHeaderBackground.module.css'

const IconHeaderBackground = ({ children, title, close }) => {

    return (
        <div className={classes.IconHeaderBackground}>
            <div className={classes.Header}>
                <h3 className={classes.Title}>{title}</h3>
                <img onClick={(e) => close(e)} src={closeIcon} alt='CloseIcon' className={classes.Close} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => close(e))} />
            </div>
            {children}
        </div>
    )
}

export default IconHeaderBackground;